import Vue from 'vue'
import {api} from "../resources"
import {i18n} from "@/i18n"

export default {
    namespaced: true,
    state: {
        filters: {
            date: null
        },
        budgets: {
            copy_available: false,
            data: {
                incomes: [],
                expenses: [],
                expense_groups: [],
                goal_credit: [],
                goal_debit: [],
                widget: null
            },
            dirty: false,
        },
        budgetSelected: null,
        budgetSelectedTransactions: {
            data: [],
            dirty: false,
            pagination: {
                current_page: null,
                pages: null
            }
        }
    },
    getters: {
        filter_month_name: state => Vue.prototype.$moment(state.filters.date, 'YYYY-MM').locale(i18n.locale).format('MMMM'),
        budgetCommonProps: (state, getters) => (budget) => ({
            id: budget.id,
            type: budget.type,
            icon: 'wallet',
            comment: budget.comment,
            sum_plan: budget.sum_plan,
            sum_fact: budget.sum_fact,
            excluded_transactions: budget.excluded_transactions,
            currency: getters.budgetCurrency(budget)
        }),
        budgetIncomeProps: (state, getters) => (budget) => ({
            ...getters.budgetCommonProps(budget),
            title: budget.incomeSource.title,
            icon: budget.incomeSource.icon
        }),
        budgetExpenseProps: (state, getters) => (budget) => ({
            ...getters.budgetCommonProps(budget),
            title: budget.expenseCategory.title,
            icon: budget.expenseCategory.icon
        }),
        budgetGoalProps: (state, getters) => (budget) => ({
            ...getters.budgetCommonProps(budget),
            title: budget.goal.goal_title,
            icon: 'piggy_bank'
        }),
        incomes: state => state.budgets.data.incomes,
        expensesGroups: state => {
            let g = [...state.budgets.data.expense_groups],
                e = [...state.budgets.data.expenses];
            return g.map(group => ({
                ...group,
                childs: e.filter(expense => expense.expenseCategory.group_id === group.id)
            }));
        },
        expensesWOGroup: state => {
            return [...state.budgets.data.expenses].filter(expense => !expense.expenseCategory.group_id);
        },
        goalCreditBudgets: state => state.budgets.data.goal_credit,
        goalDebitBudgets: state => state.budgets.data.goal_debit,
        widgetData: state => state.budgets.data.widget,
        budgetTitle: () => (budget) => {
            let title = '';
            switch (budget.type) {
                case 1:
                    title = budget.incomeSource.title;
                    break;
                case 2:
                    title = budget.expenseCategory.title;
                    break;
                case 3:
                case 4:
                    title = budget.goal.goal_title;
                    break;
            }
            return title;
        },
        budgetCurrency: (state, getters, rootState, rootGetters) => (budget) => {
            if ([3, 4].includes(budget.type)) {
                return budget.goal.currency;
            } else {
                return rootGetters['space/spaceCurrency'];
            }
        },
        budgetTransactionsQuery: (state, getters, rootState) => (budget) => {
            let query = {
                space_id: rootState.space.current_space.data.id,
                date_start: Vue.prototype.$moment(state.filters.date, 'YYYY-MM').startOf('month').unix(),
                date_end: Vue.prototype.$moment(state.filters.date, 'YYYY-MM').endOf('month').unix(),
                page: state.budgetSelectedTransactions.pagination.current_page
            }
            switch (budget.type) {
                case 1:
                    query.income_source_id = budget.incomeSource.id;
                    query.is_income = 1
                    break;
                case 2:
                    query.expense_category_id = budget.expenseCategory.id;
                    query.is_expense = 1
                    query.is_transfer = 1
                    break;
                case 3:
                case 4:
                    query.account_id = budget.goal_id;
                    query.is_income = 1
                    query.is_expense = 1
                    query.is_transfer = 1
                    break;
            }
            return query;
        },
        budgetTransactions: state => {
            const transactionsByDate = {}
            state.budgetSelectedTransactions.data.forEach(item => {
                const date = Vue.prototype.$moment.unix(item.date).startOf('day').format('DD-MM-YYYY');
                if (!transactionsByDate[date]) {
                    transactionsByDate[date] = []
                }
                transactionsByDate[date].push(item);
            })
            return transactionsByDate;
        },
        budgetTypeHelper: () => (type) => {
            switch (type) {
                case 1:
                    return 'incomes';
                case 2:
                    return 'expenses';
                case 3:
                    return 'goal_debit';
                case 4:
                    return 'goal_credit';
            }
        }
    },
    actions: {
        createBudget({}, data) {
            return api.budget_create.save(data);
        },
        copyBudget({}, data) {
            return api.budget_copy.save(data);
        },
        getBudgets({rootState, state, commit}) {
            // commit('setBudgetsDirty')
            const date = state.filters.date.split('-')
            const data = {
                year: date[0],
                month: date[1],
                timezone: Vue.prototype.$moment.tz.guess(),
                space_id: rootState.space.current_space.data.id
            }
            api.budgets.get(data).then((res) => {
                if (res.body.success) {
                    commit('setBudgets', res.body);
                }
            })
        },
        updateBudget({commit}, data) {
            return api.budgets.update({id: data.id}, data)
        },
        async selectBudget({commit, state, dispatch}, budget) {
            if (!!state.budgetSelected && state.budgetSelected.id === budget.id) {
                commit('setSelectedBudget', null)
                commit('setBudgetTransactions', [])
                commit('setBudgetTransactionsPage', null)
            } else {
                commit('setSelectedBudget', budget)
                commit('setBudgetTransactionsPage', 1)
                commit('setBudgetTransactionsDirty')

                dispatch('loadBudgetsTransactions', budget)
            }
        },
        async loadBudgetsTransactions({commit, getters}, budget) {
            try {
                let transactionsQuery = getters.budgetTransactionsQuery(budget);
                const res = await api.transactions.get(transactionsQuery)
                if (res.body.success) {
                    commit('setBudgetTransactions', res.body.data)
                } else {
                    console.log(res)
                }
            } catch (e) {
                console.log(e)
            }
        },
        async loadMoreBudgetTransactions({commit, getters, state}) {
            try {
                let transactionsQuery = getters.budgetTransactionsQuery(state.budgetSelected);
                const res = await api.transactions.get(transactionsQuery)
                if (res.body.success) {
                    commit('pushBudgetTransactions', res.body.data);
                } else {
                    console.log(res)
                }
            } catch (e) {
                console.log(e)
            }
        },
    },
    mutations: {
        clearBudgets(state) {
            state.budgets.dirty = false
            state.budgets.copy_available = false
            state.budgets.data.incomes = []
            state.budgets.data.expenses = []
            state.budgets.data.expense_groups = []
            state.budgets.data.goal_credit = []
            state.budgets.data.goal_debit = []
            state.budgets.data.widget = null
            state.budgetSelected = null
        },
        setDateFilter(state, data) {
            state.filters.date = data;
        },
        setBudgetsDirty(state) {
            state.budgets.dirty = true;
        },
        setBudgets(state, body) {
            state.budgets.dirty = false
            state.budgets.copy_available = body.copy_available
            state.budgets.data.incomes = body.data.income
            state.budgets.data.expenses = body.data.expense
            state.budgets.data.expense_groups = body.data.expense_groups
            state.budgets.data.goal_credit = body.data.goal_credit
            state.budgets.data.goal_debit = body.data.goal_debit
            state.budgets.data.widget = body.data.widget
        },
        setNewSum(state, data) {
            let budgetCategories = [...state.budgets.data[data.budget_type]];
            budgetCategories = budgetCategories.map(item => {
                if (item.id === data.id) {
                    return {...item, sum_plan: data.sum_plan}
                } else {
                    return item
                }
            });
            state.budgets.data[data.budget_type] = budgetCategories
        },
        setNewComment(state, data) {
            let budgetCategories = [...state.budgets.data[data.budget_type]];
            budgetCategories = budgetCategories.map(item => {
                if (item.id === data.id) {
                    return {...item, comment: data.comment}
                } else {
                    return item
                }
            });
            state.budgets.data[data.budget_type] = budgetCategories
        },
        setSelectedBudget(state, budget_obj) {
            state.budgetSelected = budget_obj;
        },
        setBudgetTransactionsDirty(state) {
            state.budgetSelectedTransactions.dirty = true;
        },
        setBudgetTransactions(state, data) {
            state.budgetSelectedTransactions.data = data.rows;
            state.budgetSelectedTransactions.pagination.pages = Math.ceil(data.length / 20);
            state.budgetSelectedTransactions.dirty = false;
        },
        pushBudgetTransactions(state, data) {
            state.budgetSelectedTransactions.data.push(...data.rows);
        },
        setBudgetTransactionsPage(state, num) {
            state.budgetSelectedTransactions.pagination.current_page = num;
        }
    }
}